import { Dispatch } from "@reduxjs/toolkit";
import { updateOpeningSource, openLeadFormModal } from "./data/leadFormReducer";

class LeadFormDispatcher {
  private dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  handleOnEnquireClick({
    data,
    source,
    page,
    heading,
    referDetails,
  }: {
    data: any;
    source: string;
    page?: number;
    heading?: string;
    referDetails?: any;
  }) {
    this.dispatch(updateOpeningSource({ openingSource: source }));
    this.dispatch(
      openLeadFormModal({
        inventory: data,
        referDetails,
        inModal: true,
        ...(page && { leadFormPage: page }),
        ...(heading && { leadFormModalHeading: heading }),
      }),
    );
  }
}

export default LeadFormDispatcher;
